// src/store/Slices/passwordResetSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../API/api';

// 1) طلب كود الاسترجاع
export const requestPasswordReset = createAsyncThunk(
  'passwordReset/request',
  async (email, { rejectWithValue }) => {
    try {
      const res = await api.post('/auth/forgot-password', { email });
      return res.data; // { message, tempResetId, expiresInMs }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to request reset code');
    }
  }
);

// 2) التحقق من الـ OTP
export const verifyResetOtp = createAsyncThunk(
  'passwordReset/verifyOtp',
  async ({ tempResetId, otp }, { rejectWithValue }) => {
    try {
      const res = await api.post('/auth/verify-reset-otp', { tempResetId, otp });
      return res.data; // { message }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Invalid or expired OTP');
    }
  }
);

// 3) تعيين كلمة مرور جديدة
export const resetPassword = createAsyncThunk(
  'passwordReset/reset',
  async ({ tempResetId, newPassword }, { rejectWithValue }) => {
    try {
      const res = await api.post('/auth/reset-password', { tempResetId, newPassword });
      return res.data; // { message }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to reset password');
    }
  }
);

const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState: {
    step: 0, // 0=email, 1=otp, 2=new password, 3=done
    email: '',
    tempResetId: '',
    loading: false,
    error: null,
    successMsg: null,
  },
  reducers: {
    setEmail(state, action) { state.email = action.payload; },
    setStep(state, action) { state.step = action.payload; },
    clearResetState(state) {
      state.step = 0;
      state.email = '';
      state.tempResetId = '';
      state.loading = false;
      state.error = null;
      state.successMsg = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // requestPasswordReset
      .addCase(requestPasswordReset.pending, (s) => { s.loading = true; s.error = null; s.successMsg = null; })
      .addCase(requestPasswordReset.fulfilled, (s, a) => {
        s.loading = false;
        s.successMsg = a.payload?.message || 'Code sent';
        s.tempResetId = a.payload?.tempResetId || '';
        s.step = 1;
      })
      .addCase(requestPasswordReset.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      // verifyResetOtp
      .addCase(verifyResetOtp.pending, (s) => { s.loading = true; s.error = null; s.successMsg = null; })
      .addCase(verifyResetOtp.fulfilled, (s, a) => {
        s.loading = false;
        s.successMsg = a.payload?.message || 'OTP verified';
        s.step = 2;
      })
      .addCase(verifyResetOtp.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      // resetPassword
      .addCase(resetPassword.pending, (s) => { s.loading = true; s.error = null; s.successMsg = null; })
      .addCase(resetPassword.fulfilled, (s, a) => {
        s.loading = false;
        s.successMsg = a.payload?.message || 'Password reset successfully';
        s.step = 3;
      })
      .addCase(resetPassword.rejected, (s, a) => { s.loading = false; s.error = a.payload; });
  },
});

export const { setEmail, setStep, clearResetState } = passwordResetSlice.actions;
export default passwordResetSlice.reducer;
